import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { IPensionState } from './store/pension.state';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { setPensionAction } from './store/pension.actions';
import { getPensionSelectors } from './store/pension.selectors';
import { IPension } from 'src/app/modules/interfaces/pensions.interface';
import { PensionsService } from 'src/app/services/pensions.service';
import { getCookie } from 'src/app/utils/get-cookie';

@Component({
  selector: 'app-pension',
  templateUrl: './pension.component.html',
  styleUrls: ['./pension.component.scss'],
})
export class PensionComponent implements OnInit {
  @Output() formSaved = new EventEmitter<void>();
  formsId: number;
  pensionData: IPension = {
    id: 0,
    has_pension: null,
    pension_types_id: null,
    value_invested: null,
    montly_value: null,
    wants_pension_proposal: null,
  };

  pensionTypesMap = {
    1: 'PGBL (Plano Gerador de Benefício Livre)',
    2: 'VGBL (Vida Gerador de Benefício Livre)',
    3: 'Não sei',
  };

  isLoading = true;
  isSaving = false;
  saveButtonText = 'Salvar';
  saveButtonClass = 'btn-primary';

  dataState$: Observable<IPensionState>;
  dataState: IPensionState;

  constructor(private store: Store, private pensionService: PensionsService) {
    this.formsId = Number(getCookie('formsId'));
  }

  ngOnInit(): void {
    this.getState();
    this.loadPensionData();
  }

  loadPensionData(): void {
    this.isLoading = true;
    this.pensionService.getPensionsData(this.formsId).subscribe((response) => {
      if (response) {
        this.pensionData = {
          id: response.id,
          has_pension: response.has_pension,
          pension_types_id: response.pension_types_id,
          value_invested: response.value_invested || null,
          montly_value: response.montly_value || null,
          wants_pension_proposal: response.wants_pension_proposal,
        };
        this.saveState();
      }
    });
  }

  saveForm(): void {
    this.isSaving = true;
    this.saveButtonText = 'Salvando...';
    this.saveButtonClass = 'btn-secondary';

    const updateData: any = {
      has_pension: this.pensionData.has_pension,
      pension_types_id: this.pensionData.pension_types_id,
      value_invested: this.pensionData.value_invested || null,
      montly_value: this.pensionData.montly_value || null,
      wants_pension_proposal: this.pensionData.wants_pension_proposal ? 1 : 0,
    };

    this.pensionService
      .updatePensionsData(this.formsId, this.pensionData.id, updateData)
      .subscribe({
        next: () => {
          this.isSaving = false;
          this.saveButtonText = 'Salvo';
          this.saveButtonClass = 'btn-primary';
          this.saveState();
          this.formSaved.emit();
        },
        error: (err) => {
          this.isSaving = false;
          this.saveButtonText = 'Erro ao salvar';
          this.saveButtonClass = 'btn-danger';
          console.error('Erro ao atualizar os dados de previdência', err);
        },
      });
  }

  saveState(): void {
    const pensionName =
      this.pensionTypesMap[this.pensionData.pension_types_id] || '';

    this.dataState = {
      ...this.dataState,
      check: true,
      pension: this.pensionData.has_pension === 1,
      typePension: pensionName,
      amount: this.pensionData.value_invested || 0,
      notes: this.pensionData.montly_value || 0,
      interest: this.pensionData.wants_pension_proposal === 1,
    };

    this.setState(this.dataState);
  }

  onFieldChange(): void {
    if (!this.isSaving) {
      this.saveButtonText = 'Salvar';
      this.saveButtonClass = 'btn-primary';
    }
  }

  startTrial(): void {
    this.setState(this.dataState);
  }

  setState(data: IPensionState) {
    this.store.dispatch(setPensionAction(data));
    this.isLoading = false;

  }

  getState() {
    this.dataState$ = this.store.select(getPensionSelectors);

    this.dataState$.subscribe((value) => {
      this.dataState = {
        ...(this.dataState = value),
      };
    });
  }

  setValuesForm(): void {
    this.dataState.check = false;
    if (this.dataState.pension != undefined) {
      this.dataState.check = true;
    }
    this.setState(this.dataState);
  }

  updateAmount(event): void {
    this.dataState.amount = event;
    this.setValuesForm();
  }

  updateNotes(event): void {
    this.dataState.notes = event;
    this.setValuesForm();
  }
}
